export type Location = { slug: string; display_name: string };

// SP and RJ are pinned at the top — consumers (AlertModal Select, buscar
// filter, SEO routes) treat them as featured and the rest as a separate
// alphabetical block. Order below mirrors that contract.
export const LOCATIONS: Location[] = [
  { slug: "sp", display_name: "São Paulo (SP)" },
  { slug: "rj", display_name: "Rio de Janeiro (RJ)" },
  // Rest alphabetical by Portuguese state name.
  { slug: "ac", display_name: "Acre (AC)" },
  { slug: "al", display_name: "Alagoas (AL)" },
  { slug: "ap", display_name: "Amapá (AP)" },
  { slug: "am", display_name: "Amazonas (AM)" },
  { slug: "ba", display_name: "Bahia (BA)" },
  { slug: "ce", display_name: "Ceará (CE)" },
  { slug: "df", display_name: "Distrito Federal (DF)" },
  { slug: "es", display_name: "Espírito Santo (ES)" },
  { slug: "go", display_name: "Goiás (GO)" },
  { slug: "ma", display_name: "Maranhão (MA)" },
  { slug: "mt", display_name: "Mato Grosso (MT)" },
  { slug: "ms", display_name: "Mato Grosso do Sul (MS)" },
  { slug: "mg", display_name: "Minas Gerais (MG)" },
  { slug: "pa", display_name: "Pará (PA)" },
  { slug: "pb", display_name: "Paraíba (PB)" },
  { slug: "pr", display_name: "Paraná (PR)" },
  { slug: "pe", display_name: "Pernambuco (PE)" },
  { slug: "pi", display_name: "Piauí (PI)" },
  { slug: "rn", display_name: "Rio Grande do Norte (RN)" },
  { slug: "rs", display_name: "Rio Grande do Sul (RS)" },
  { slug: "ro", display_name: "Rondônia (RO)" },
  { slug: "rr", display_name: "Roraima (RR)" },
  { slug: "sc", display_name: "Santa Catarina (SC)" },
  { slug: "se", display_name: "Sergipe (SE)" },
  { slug: "to", display_name: "Tocantins (TO)" },
];

export const LOCATION_BY_SLUG: Record<string, string> = Object.fromEntries(
  LOCATIONS.map((l) => [l.slug, l.display_name])
);

// SEO-eligible UFs: those with at least MIN_LISTINGS_TO_INDEX active
// listings on the most recent audit. SEO routes (sitemap, cross-state
// links) iterate this subset to avoid generating thin/empty pages and
// pointing users at routes that would 404.
//
// Maintained by hand against `SELECT location, COUNT(*) FROM listings
// WHERE status='active' GROUP BY location`. Update when inventory
// crosses the threshold either direction. Form selectors (AlertModal,
// /buscar) keep using the full LOCATIONS list so users can still pick
// any state — the gate is only on the indexed/linked SEO surfaces.
const SEO_SLUGS = new Set([
  "sp", "rj",
  "al", "am", "ba", "ce", "df", "es", "go", "ma", "mg", "pa",
  "pb", "pe", "pi", "pr", "rn", "rs", "sc", "se",
]);

export const SEO_LOCATIONS: Location[] = LOCATIONS.filter((l) =>
  SEO_SLUGS.has(l.slug),
);
